import { RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import reportWebVitals from "./reportWebVitals";
import "./styles/index.scss";
import { createRoot } from "react-dom/client";
import { StrictMode } from "react";
import { createCustomBrowserRouter } from "./_configuration/routing/paths/index";
import { Authenticator } from "@aws-amplify/ui-react";
import store from "./_configuration/redux";
import configureAmplify from "./_configuration/amplify";
import GoogleTagManager from "./Analytics/components/GoogleTagManager";
import { GTAG_ID, GTM_ID } from "./Analytics/util";
import{ DateFns } from "@osu/react-ui"

(async () => {
  try {
    await configureAmplify();
  } catch (error) {
    console.error(error)
  } finally {
    const root = createRoot(document.getElementById("root"));
    root.render(
      <StrictMode>
        <DateFns.LocalizationProvider>
          {(GTM_ID || GTAG_ID) &&  <GoogleTagManager />}
            <Authenticator.Provider>
              <Provider store={store}>
                <RouterProvider router={createCustomBrowserRouter({ dispatch: store.dispatch, getState: store.getState })} />
              </Provider>
            </Authenticator.Provider>
        </DateFns.LocalizationProvider>
      </StrictMode>
    );
  }
})();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
